<template>
  <v-app id="app">
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
// const Main = () => import('./components/Main')
export default {
  name: 'App',
  components: {
    // Main
  }
}
</script>

<style>
</style>
